<template>
    <v-container class="fill-height" fluid>
        <SendLinkDialog
            :is-open="sendLinkDialog"
            @on-close="closeSendLinkDialog"
        />

        <v-container class="pa-0">
            <v-row align="center" justify="center">
                <v-col cols="12" sm="8" md="6" lg="5" xl="4">
                    <v-form @submit.prevent="login">
                        <v-card>
                            <v-toolbar flat dark color="secondary">
                                <v-toolbar-title>Logowanie</v-toolbar-title>
                            </v-toolbar>

                            <v-container>
                                <v-row justify="center">
                                    <v-col cols="12">
                                        <v-text-field
                                            v-model="username"
                                            label="Login"
                                            required
                                            prepend-icon="mdi-account"
                                            filled
                                            hide-details
                                        />
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            v-model="password"
                                            label="Hasło"
                                            required
                                            type="password"
                                            prepend-icon="mdi-lock"
                                            filled
                                            hide-details
                                        />
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-btn
                                            type="submit"
                                            color="success"
                                            medium
                                            class="mt-1"
                                            data-sentry-label="Zaloguj"
                                            :loading="actionLoading"
                                        >
                                            Zaloguj
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-row justify="center">
                                    <v-col cols="auto" class="pa-0">
                                        <v-btn
                                            text
                                            class="button-forgot-password"
                                            @click="showSendLinkDialog()"
                                        >
                                            Nie pamiętasz hasła?
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-form>
                </v-col>
            </v-row>
        </v-container>
    </v-container>
</template>

<script>
import SendLinkDialog from './SendLinkDialog'
import { errorHandler } from '@/utils/errorHandler'
import { required } from 'vuelidate/lib/validators'

export default {
    components: {
        SendLinkDialog
    },
    data() {
        return {
            username: '',
            password: '',
            actionLoading: false,
            sendLinkDialog: false
        }
    },
    validations() {
        return {
            username: { required },
            password: { required }
        }
    },
    methods: {
        showSendLinkDialog() {
            this.sendLinkDialog = true
        },
        closeSendLinkDialog() {
            this.sendLinkDialog = false
        },
        login() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: 'Login i hasło są wymagane.'
                })

                return
            }
            this.actionLoading = true

            this.$store.dispatch('login', {
                username: this.username,
                password: this.password
            }).then(() => {
                this.$store.dispatch('getUserPermissions')
                    .then(() => {
                        if (this.$store.state.common.isAppUpdated) {
                            window.location.reload(true)
                        }
                        const userId = this.$store.state.user.userId

                        this.$store.dispatch('getUser', userId)
                            .catch(error => errorHandler(error))

                        this.$store.dispatch('dashboard/getDashboardSections')
                            .catch(error => errorHandler(error))

                        this.$store.dispatch('administration/getProductionDepartments', {query:'?hasMachines=true'})
                            .catch(error => errorHandler(error))

                        this.$store.dispatch('dashboard/clearDashboardItems')

                        this.$store.dispatch('dashboard/getDashboardItems')
                            .then((response) => {
                                let promises = []

                                response.data.results.forEach(item => {
                                    if (item.codeName === 'machineReview') {
                                        this.$store.dispatch('dashboard/setMachinesDashboard', item)
                                    } else {
                                        promises.push(this.$store.dispatch('dashboard/getDashboardItem', {
                                            item: item,
                                            paginate: '',
                                            query: ''
                                        }))
                                    }
                                })
                                Promise.all(promises)
                                    .then(responses => {
                                        responses.forEach(response => {
                                            this.$store.dispatch('dashboard/setDashboardItems', response.data)
                                        })
                                    })
                                    .catch(error => {
                                        errorHandler(error)
                                    })
                                    .finally(() => {
                                        this.actionLoading = false
                                        this.$router.push({ name: 'dashboard' })
                                            .catch(error => {
                                                errorHandler(error)
                                            })
                                    })
                            })
                            .catch(error => {
                                this.$router.push({ name: 'dashboard' })
                                    .catch(error => {
                                        errorHandler(error)
                                    })
                                errorHandler(error)
                            })
                    })
                    .catch(error => {
                        this.actionLoading = false
                        errorHandler(error)
                    })
            })
                .catch(error => {
                    this.actionLoading = false
                    errorHandler(error)
                })

        }
    }
}
</script>
